import { useQueryClient } from "@tanstack/react-query";
import { Button, Popup, Space } from "antd-mobile";
import Big from "big.js";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";

import { CheckCircleFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { CustomDialog, CustomList } from "../../../../../../components";
import queryKey from "../../../../../../enumerations/queryKey";
import { moneyFormat } from "../../../../../../plugins/numberFormat";
import { getUserCurrency } from "../../../../../../plugins/utils";
import { usePutWithdraw } from "../../../../../Personal/hooks/personal.hook";
import styles from "./style.module.scss";
import "./style.scss";

function TransferPopup(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userWallet } = props;
  const cache = useQueryClient();
  const handler = useRef();
  const { mutate: putWithdraw } = usePutWithdraw({
    onSuccess: () => {
      cache.invalidateQueries(queryKey.AGENT_BALANCE);
      handler.current = CustomDialog({
        type: "confirm",
        dialogProps: {
          destroyOnClose: true,
          content: (
            <div className={styles.popupContent}>
              <CheckCircleFilled
                style={{
                  color: "var(--adm-color-success)",
                  fontSize: "40px",
                  marginBottom: "8px",
                }}
              />
              <div>{t("mobile.personal.transfer.submit.complete")}</div>
            </div>
          ),
          onConfirm: () => {
            navigate("/transaction/?tab=withdraw");
          },
          cancelText: <>{t("normal.confirm2")}</>,
          confirmText: <>{t("normal.viewRecord")}</>,
        },
      });
      props.onClose();
    },
  });
  const userCurrency = getUserCurrency();
  const popupStyle = {
    height: "auto",
    borderRadius: "16px 16px 0 0",
    padding: "32px 24px 16px 24px",
  };
  const listTextStyle = {
    color: "var(--popup-cashout-value-white)",
    fontWeight: 700,
    fontSize: "var(--fontSetting-bigger)",
  };
  const buttonStyle = {
    // width: "120px",
    minHeight: "40px",
    fontWeight: 500,
    padding: "8px 12px",
  };
  const listItems = [
    {
      title: t("pageContainer.trans.comissionValue"),
      contentRender: () => <span style={listTextStyle}>{moneyFormat(userWallet[0]?.money)}</span>,
    },
    {
      title: t("pageContainer.trans.exchangeRate"),
      contentRender: () => (
        <span style={listTextStyle}>
          1 {userWallet[0]?.currency} : {userWallet[0]?.rate} {userCurrency}
        </span>
      ),
    },
    {
      title: t("pageContainer.trans.exchangeBefore"),
      contentRender: () => {
        const transMoney = new Big(userWallet[0]?.money || 0).round(2, 0).toString() ?? "0";
        return (
          <span style={listTextStyle}>
            {transMoney
              ? moneyFormat(new Big(transMoney)?.round(0, 0).mul(userWallet[0]?.rate).toString())
              : ""}
            <span style={{ marginLeft: 5 }}>{userCurrency}</span>
          </span>
        );
      },
    },
    {
      title: t("pageContainer.trans.exchangeValue"),
      contentRender: () => {
        const transMoney = new Big(userWallet[0]?.money).round(2, 0).toString() ?? "0";
        return (
          <span style={{ ...listTextStyle, color: "var(--adm-color-success)" }}>
            {transMoney
              ? moneyFormat(
                  new Big(transMoney)?.round(0, 0).mul(userWallet[0]?.rate).round(0, 0).toString(),
                )
              : ""}
            <span style={{ marginLeft: 5 }}>{userCurrency}</span>
          </span>
        );
      },
    },
  ];
  return (
    <Popup className="custom-drawer-popup cashout-popup" {...props} bodyStyle={popupStyle}>
      <div className={styles.transferContainer}>
        <div className={styles.title}>{t("mobile.personal.transfer")}</div>
        <CustomList listItems={listItems} />
        <span className={styles.hint}>{t("mobile.personal.transfer.hint")}</span>
        <div className={styles.buttonGroup}>
          <Space justify="center" align="center" style={{ "--gap": "16px" }} block>
            <Button
              color="primary"
              fill="none"
              style={{
                ...buttonStyle,
                "--background-color": "var(--button-secondary-bg)",
                "--text-color": "var(--button-secondary-text)",
                width: "120px",
              }}
              onClick={() => {
                props.onClose();
              }}
            >
              {t("normal.cancel")}
            </Button>
            <Button
              color="primary"
              loading="auto"
              fill="solid"
              style={{
                ...buttonStyle,
                "--background-color": "var(--button-primary-bg)",
                "--text-color": "var(--button-primary-text)",
                width: "120px",
              }}
              onClick={async () => {
                const transMoney = new Big(userWallet[0]?.money).round(2, 0).toString() ?? "0";
                await putWithdraw({
                  trade_amount: new Big(transMoney)?.round(0, 0).toString(),
                });
              }}
            >
              {t("pageContainer.trans.confirm")}
            </Button>
          </Space>
        </div>
      </div>
    </Popup>
  );
}

export default TransferPopup;
